import React, { useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";

const API = process.env.REACT_APP_API_URL || "";

const EMPTY_FORM = {
  visitor_name: "",
  visitor_phone: "",
  visitor_cell: "",
  visitor_village: "",
  visitor_sector: "",
  visitor_district: "",
  visited_person_name: "",
  visited_person_phone: "",
  visited_person_id: "",
};

export default function Abashyitsi() {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY_FORM);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all"); // all | ari_imbere | yavuyeho
  const [deleteId, setDeleteId] = useState(null);

  const showToast = (msg, type = "ok") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4000);
  };

  const fetchVisitors = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/api/visitors`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVisitors(res.data || []);
    } catch {
      showToast("Habaye ikosa mu gusoma amakuru.", "err");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVisitors();
  }, [fetchVisitors]);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.visitor_name.trim() || !form.visited_person_name.trim()) {
      showToast("Amazina y'uwasuye n'uwasuwe ni ngombwa.", "err");
      return;
    }
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/api/visitors`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showToast("✅ Umushyitsi yanditswe neza!");
      setForm(EMPTY_FORM);
      setShowForm(false);
      fetchVisitors();
    } catch {
      showToast("Habaye ikosa mu kubika.", "err");
    } finally {
      setSaving(false);
    }
  };

  const handleCheckout = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/api/visitors/${id}/checkout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showToast("✅ Umushyitsi yavuyeho!");
      fetchVisitors();
    } catch {
      showToast("Habaye ikosa.", "err");
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/api/visitors/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showToast("🗑️ Umushyitsi yasibwe neza!");
      setDeleteId(null);
      fetchVisitors();
    } catch {
      showToast("Habaye ikosa mu gusiba.", "err");
    }
  };

  const filtered = visitors.filter((v) => {
    const matchSearch =
      !search ||
      v.visitor_name?.toLowerCase().includes(search.toLowerCase()) ||
      v.visitor_village?.toLowerCase().includes(search.toLowerCase()) ||
      v.visited_person_name?.toLowerCase().includes(search.toLowerCase());
    const st = v.status?.toLowerCase();
    const matchFilter =
      filter === "all" ||
      (filter === "ari_imbere" && st === "ari imbere") ||
      (filter === "yavuyeho" && (st === "yavuyeho" || st === "yavuyeho"));
    return matchSearch && matchFilter;
  });

  const activeCount = visitors.filter((v) => v.status?.toLowerCase() === "ari imbere").length;
  const todayCount = visitors.filter((v) => {
    const d = new Date(v.check_in);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  }).length;

  const fmt = (dt) =>
    dt
      ? new Date(dt).toLocaleString("rw-RW", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "—";

  return (
    <div style={{ fontFamily: "Nunito Sans, sans-serif", color: "#e2e8f0" }}>
      {/* ── HEADER ── */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 20,
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: "1.3rem",
              fontWeight: 800,
              color: "#e2e8f0",
            }}
          >
            <i
              className="bi bi-person-walking"
              style={{ color: "#06b6d4", marginRight: 8 }}
            />
            Abashyitsi
          </h2>
          <p style={{ margin: "4px 0 0", fontSize: "0.78rem", color: "#64748b" }}>
            Gukurikirana abantu baza gusura mu mudugudu
          </p>
        </div>
        <button
          onClick={() => {
            setForm(EMPTY_FORM);
            setShowForm(true);
          }}
          style={btnStyle("#06b6d4")}
        >
          <i className="bi bi-plus-lg" style={{ marginRight: 6 }} />
          Ongeraho Umushyitsi
        </button>
      </div>

      {/* ── STATS ── */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
          gap: 12,
          marginBottom: 20,
        }}
      >
        {[
          {
            label: "Bose",
            value: visitors.length,
            icon: "people-fill",
            color: "#6366f1",
          },
          {
            label: "Ari Imbere",
            value: activeCount,
            icon: "person-check-fill",
            color: "#10b981",
          },
          {
            label: "Uyu Munsi",
            value: todayCount,
            icon: "calendar-check-fill",
            color: "#f59e0b",
          },
          {
            label: "Yavuyeho",
            value: visitors.length - activeCount,
            icon: "person-dash-fill",
            color: "#94a3b8",
          },
        ].map((s) => (
          <div key={s.label} style={statCard(s.color)}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: `${s.color}18`,
                color: s.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
              }}
            >
              <i className={`bi bi-${s.icon}`} />
            </div>
            <div>
              <div
                style={{ fontSize: "1.5rem", fontWeight: 800, color: "#e2e8f0" }}
              >
                {s.value}
              </div>
              <div style={{ fontSize: "0.68rem", color: "#64748b", fontWeight: 600 }}>
                {s.label}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── FILTERS ── */}
      <div
        style={{
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
          marginBottom: 16,
          alignItems: "center",
        }}
      >
        <div style={searchBox}>
          <i
            className="bi bi-search"
            style={{ color: "#64748b", fontSize: "0.82rem" }}
          />
          <input
            type="text"
            placeholder="Shakisha umushyitsi cyangwa umudugudu..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={searchInput}
          />
        </div>
        {["all", "ari_imbere", "yavuyeho"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={filterBtn(filter === f)}
          >
            {f === "all" ? "Bose" : f === "ari_imbere" ? "Ari Imbere" : "Yavuyeho"}
          </button>
        ))}
        <button
          onClick={fetchVisitors}
          style={{
            ...filterBtn(false),
            marginLeft: "auto",
            color: "#06b6d4",
            borderColor: "rgba(6,182,212,0.3)",
          }}
        >
          <i className="bi bi-arrow-clockwise" />
        </button>
      </div>

      {/* ── TABLE ── */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 0", color: "#64748b" }}>
          <div
            className="spinner-border spinner-border-sm text-info"
            role="status"
          />
          <span style={{ marginLeft: 10 }}>Gutegereza...</span>
        </div>
      ) : filtered.length === 0 ? (
        <div style={emptyBox}>
          <i
            className="bi bi-person-x"
            style={{ fontSize: "2.5rem", color: "#334155", marginBottom: 8 }}
          />
          <div style={{ color: "#64748b" }}>Nta mushyitsi wabonetse</div>
        </div>
      ) : (
        <div style={{ overflowX: "auto", borderRadius: 14, border: "1px solid rgba(99,102,241,0.1)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.82rem" }}>
            <thead>
              <tr style={{ background: "rgba(22,28,45,0.95)" }}>
                {[
                  "#",
                  "Amazina",
                  "Telefoni",
                  "Aho Yaturutse",
                  "Uwasuwe",
                  "Tel. Uwasuwe",
                  "Imiterere",
                  "Yinjiye",
                  "Yasohotse",
                  "Ibikorwa",
                ].map((h) => (
                  <th key={h} style={th}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((v, i) => (
                <tr
                  key={v.id}
                  style={{
                    borderBottom: "1px solid rgba(99,102,241,0.07)",
                    background: i % 2 === 0 ? "rgba(22,28,45,0.6)" : "rgba(15,20,35,0.6)",
                  }}
                >
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, fontWeight: 600, color: "#e2e8f0" }}>
                    {v.visitor_name}
                  </td>
                  <td style={td}>{v.visitor_phone || "—"}</td>
                  <td style={td}>
                    <span style={{ color: "#94a3b8" }}>
                      {[v.visitor_village, v.visitor_cell, v.visitor_sector, v.visitor_district]
                        .filter(Boolean)
                        .join(", ") || "—"}
                    </span>
                  </td>
                  <td style={{ ...td, fontWeight: 600, color: "#a5b4fc" }}>
                    {v.visited_person_name}
                  </td>
                  <td style={td}>{v.visited_person_phone || "—"}</td>
                  <td style={td}>
                    <span
                      style={{
                        padding: "3px 10px",
                        borderRadius: 20,
                        fontSize: "0.72rem",
                        fontWeight: 700,
                        background:
                          v.status?.toLowerCase() === "ari imbere"
                            ? "rgba(16,185,129,0.15)"
                            : "rgba(100,116,139,0.15)",
                        color:
                          v.status?.toLowerCase() === "ari imbere" ? "#10b981" : "#94a3b8",
                        border: `1px solid ${
                          v.status?.toLowerCase() === "ari imbere"
                            ? "rgba(16,185,129,0.3)"
                            : "rgba(100,116,139,0.2)"
                        }`,
                      }}
                    >
                      {v.status?.toLowerCase() === "ari imbere" ? "🟢 Ari Imbere" : "⚪ Yavuyeho"}
                    </span>
                  </td>
                  <td style={{ ...td, color: "#94a3b8", whiteSpace: "nowrap" }}>
                    {fmt(v.check_in)}
                  </td>
                  <td style={{ ...td, color: "#94a3b8", whiteSpace: "nowrap" }}>
                    {fmt(v.check_out)}
                  </td>
                  <td style={td}>
                    <div style={{ display: "flex", gap: 4 }}>
                      {v.status?.toLowerCase() === "ari imbere" && (
                        <button
                          onClick={() => handleCheckout(v.id)}
                          title="Yavuyeho"
                          style={actionBtn("#10b981")}
                        >
                          <i className="bi bi-box-arrow-right" />
                        </button>
                      )}
                      <button
                        onClick={() => setDeleteId(v.id)}
                        title="Gusiba"
                        style={actionBtn("#f43f5e")}
                      >
                        <i className="bi bi-trash3" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── ADD FORM MODAL ── */}
      {showForm && (
        <div style={modalOverlay} onClick={() => setShowForm(false)}>
          <div
            style={modalBox}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <h3 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 800, color: "#e2e8f0" }}>
                <i
                  className="bi bi-person-plus-fill"
                  style={{ color: "#06b6d4", marginRight: 8 }}
                />
                Ongeraho Umushyitsi
              </h3>
              <button
                onClick={() => setShowForm(false)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#64748b",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                }}
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={formSection}>
                <div style={sectionLabel}>
                  <i className="bi bi-person-fill" style={{ color: "#06b6d4" }} />
                  Amakuru y'Uwasuye
                </div>
                <div style={formGrid}>
                  <Field label="Amazina *" name="visitor_name" value={form.visitor_name} onChange={handleChange} placeholder="Amazina yose" required />
                  <Field label="Telefoni" name="visitor_phone" value={form.visitor_phone} onChange={handleChange} placeholder="07X XXX XXXX" />
                  <Field label="Akagari" name="visitor_cell" value={form.visitor_cell} onChange={handleChange} placeholder="Akagari aturukamo" />
                  <Field label="Umudugudu" name="visitor_village" value={form.visitor_village} onChange={handleChange} placeholder="Umudugudu" />
                  <Field label="Umurenge" name="visitor_sector" value={form.visitor_sector} onChange={handleChange} placeholder="Umurenge" />
                  <Field label="Akarere" name="visitor_district" value={form.visitor_district} onChange={handleChange} placeholder="Akarere" />
                </div>
              </div>

              <div style={formSection}>
                <div style={sectionLabel}>
                  <i className="bi bi-house-fill" style={{ color: "#a78bfa" }} />
                  Amakuru y'Uwasuwe
                </div>
                <div style={formGrid}>
                  <Field label="Amazina y'Uwasuwe *" name="visited_person_name" value={form.visited_person_name} onChange={handleChange} placeholder="Amazina yose" required />
                  <Field label="Telefoni y'Uwasuwe" name="visited_person_phone" value={form.visited_person_phone} onChange={handleChange} placeholder="07X XXX XXXX" />
                  <Field label="Indangamuntu / Reference" name="visited_person_id" value={form.visited_person_id} onChange={handleChange} placeholder="Indangamuntu cyangwa reference" />
                </div>
              </div>

              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  style={cancelBtn}
                >
                  Reka
                </button>
                <button type="submit" disabled={saving} style={btnStyle("#06b6d4")}>
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm" style={{ marginRight: 6 }} />
                      Kubika...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-lg" style={{ marginRight: 6 }} />
                      Bika
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── DELETE CONFIRM ── */}
      {deleteId && (
        <div style={modalOverlay} onClick={() => setDeleteId(null)}>
          <div
            style={{ ...modalBox, maxWidth: 380, textAlign: "center" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: 16,
                background: "rgba(244,63,94,0.1)",
                color: "#f43f5e",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",
                margin: "0 auto 16px",
              }}
            >
              <i className="bi bi-trash3-fill" />
            </div>
            <h3 style={{ color: "#e2e8f0", marginBottom: 8 }}>Gusiba Umushyitsi</h3>
            <p style={{ color: "#94a3b8", fontSize: "0.88rem", marginBottom: 24 }}>
              Urashaka koko gusiba uyu mushyitsi? Ntibizasubizwa.
            </p>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                onClick={() => setDeleteId(null)}
                style={{ ...cancelBtn, flex: 1 }}
              >
                Oya, Guma
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                style={{
                  flex: 1,
                  padding: "10px 16px",
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#f43f5e,#e11d48)",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.88rem",
                }}
              >
                <i className="bi bi-trash3" style={{ marginRight: 6 }} />
                Yego, Siba
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── TOAST ── */}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: 90,
            left: "50%",
            transform: "translateX(-50%)",
            padding: "12px 20px",
            borderRadius: 14,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontSize: "0.84rem",
            fontWeight: 500,
            zIndex: 3000,
            maxWidth: "90vw",
            border: "1px solid",
            boxShadow: "0 6px 24px rgba(0,0,0,0.25)",
            background:
              toast.type === "ok"
                ? "rgba(16,185,129,0.12)"
                : "rgba(244,63,94,0.12)",
            borderColor:
              toast.type === "ok"
                ? "rgba(16,185,129,0.25)"
                : "rgba(244,63,94,0.25)",
            color: toast.type === "ok" ? "#10b981" : "#f43f5e",
          }}
        >
          <i
            className={`bi bi-${
              toast.type === "ok" ? "check-circle-fill" : "exclamation-triangle-fill"
            }`}
          />
          {toast.msg}
        </div>
      )}
    </div>
  );
}

// ── FIELD COMPONENT ──
function Field({ label, name, value, onChange, placeholder, required }) {
  return (
    <div>
      <label
        style={{
          display: "block",
          fontSize: "0.78rem",
          fontWeight: 600,
          color: "#94a3b8",
          marginBottom: 5,
        }}
      >
        {label}
      </label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        style={{
          width: "100%",
          padding: "9px 12px",
          borderRadius: 10,
          border: "1px solid rgba(99,102,241,0.2)",
          background: "rgba(30,41,59,0.85)",
          color: "#e2e8f0",
          fontSize: "0.84rem",
          outline: "none",
          boxSizing: "border-box",
        }}
      />
    </div>
  );
}

// ── STYLES ──
const btnStyle = (color) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: "9px 18px",
  borderRadius: 10,
  border: "none",
  background: `linear-gradient(135deg, ${color}, ${color}cc)`,
  color: "#fff",
  fontWeight: 700,
  fontSize: "0.84rem",
  cursor: "pointer",
  whiteSpace: "nowrap",
});

const statCard = (color) => ({
  background: "rgba(22,28,45,0.9)",
  border: "1px solid rgba(99,102,241,0.1)",
  borderRadius: 14,
  padding: "16px 14px",
  display: "flex",
  alignItems: "center",
  gap: 12,
});

const searchBox = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "0 12px",
  background: "rgba(99,102,241,0.06)",
  border: "1px solid rgba(99,102,241,0.15)",
  borderRadius: 10,
  height: 36,
  flex: "1 1 220px",
  maxWidth: 360,
};

const searchInput = {
  border: "none",
  background: "none",
  color: "#e2e8f0",
  fontSize: "0.82rem",
  outline: "none",
  width: "100%",
};

const filterBtn = (active) => ({
  padding: "6px 14px",
  borderRadius: 8,
  border: `1px solid ${active ? "rgba(99,102,241,0.4)" : "rgba(99,102,241,0.15)"}`,
  background: active ? "rgba(99,102,241,0.15)" : "transparent",
  color: active ? "#a5b4fc" : "#64748b",
  fontSize: "0.78rem",
  fontWeight: 600,
  cursor: "pointer",
  whiteSpace: "nowrap",
});

const th = {
  padding: "10px 14px",
  textAlign: "left",
  fontSize: "0.68rem",
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  whiteSpace: "nowrap",
  borderBottom: "1px solid rgba(99,102,241,0.1)",
};

const td = {
  padding: "10px 14px",
  color: "#94a3b8",
  verticalAlign: "middle",
};

const actionBtn = (color) => ({
  width: 28,
  height: 28,
  borderRadius: 7,
  border: "none",
  background: `${color}15`,
  color,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.82rem",
});

const emptyBox = {
  textAlign: "center",
  padding: "48px 20px",
  background: "rgba(22,28,45,0.6)",
  borderRadius: 14,
  border: "1px solid rgba(99,102,241,0.08)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
};

const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.7)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  zIndex: 2000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16,
};

const modalBox = {
  background: "#161c2d",
  border: "1px solid rgba(99,102,241,0.2)",
  borderRadius: 20,
  padding: "28px 24px",
  maxWidth: 680,
  width: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
};

const formSection = {
  marginBottom: 20,
  padding: 16,
  borderRadius: 12,
  background: "rgba(99,102,241,0.04)",
  border: "1px solid rgba(99,102,241,0.1)",
};

const sectionLabel = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: "0.78rem",
  fontWeight: 700,
  color: "#94a3b8",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  marginBottom: 14,
};

const formGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: 12,
};

const cancelBtn = {
  padding: "10px 16px",
  borderRadius: 10,
  border: "1px solid rgba(99,102,241,0.2)",
  background: "rgba(99,102,241,0.06)",
  color: "#94a3b8",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: "0.84rem",
};
